// themes/light.js
// "Vibrant Branded Light" — pale blue base, white roads, no POIs, no transit.
// Color values are independent of primaryActionColor (which colors markers/CTA only).
export default [
  { elementType: "geometry", stylers: [{ color: "#eef2ff" }] },
  { elementType: "labels.text.fill", stylers: [{ color: "#444444" }] },
  { elementType: "labels.text.stroke", stylers: [{ color: "#ffffff" }] },
  { elementType: "labels.icon", stylers: [{ visibility: "off" }] },

  {
    featureType: "administrative",
    elementType: "geometry",
    stylers: [{ visibility: "on", color: "#8AA4BE" }],
  },
  // Délimitations des communes (administrative.locality en France)
  {
    featureType: "administrative.locality",
    elementType: "geometry.stroke",
    stylers: [{ visibility: "on", color: "#8AA4BE", weight: 1 }],
  },
  {
    featureType: "administrative.province",
    elementType: "geometry.stroke",
    stylers: [
      {
        visibility: "on",
      },
      {
        color: "#2b2d2cff",
      },
      {
        weight: 2,
      },
    ],
  },
  {
    featureType: "administrative.locality",
    elementType: "labels.text.fill",
    stylers: [{ color: "#444444" }],
  },
  { featureType: "administrative.land_parcel", stylers: [{ visibility: "on" }] },

  { featureType: "landscape", elementType: "geometry", stylers: [{ color: "#eef2ff" }] },
  { featureType: "landscape.natural", elementType: "geometry", stylers: [{ color: "#e6ecfa" }] },
  { featureType: "landscape", elementType: "all", stylers: [{ color: "#f2f2f2" }] },
  { featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
  { featureType: "poi.park", elementType: "geometry", stylers: [{ color: "#e0f0e3" }] },
  { featureType: "poi.business", elementType: "geometry.fill", stylers: [{ visibility: "on" }] },
  { featureType: "road", elementType: "all", stylers: [{ saturation: -100 }, { lightness: 45 }] },
  { featureType: "road", elementType: "geometry.fill", stylers: [{ color: "#ffffff" }] },
  { featureType: "road", elementType: "geometry.stroke", stylers: [{ visibility: "off" }] },
  { featureType: "road", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
  { featureType: "road.local", stylers: [{ visibility: "off" }] },
  { featureType: "road.arterial", elementType: "labels", stylers: [{ visibility: "off" }] },
  { featureType: "road.highway", elementType: "labels", stylers: [{ visibility: "off" }] },
  { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ color: "#666666" }] },

  { featureType: "transit", stylers: [{ visibility: "off" }] },

  { featureType: "water", elementType: "geometry", stylers: [{ color: "#B4D4E1" }] },
  { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#234B60" }] },
]
